import React, { useEffect, useState } from "react";
const IPBasedLoginContext = /*#__PURE__*/ React.createContext(undefined);
export const IPBasedLoginContextProvider = _ref => {
    let { children } = _ref;
    const { 0: login, 1: setLogin } = useState(undefined);
    useEffect(() => {
        const xhr = new XMLHttpRequest();
        xhr.addEventListener('load', () => {
            if (xhr.responseText) {
                const parsedResponseText = JSON.parse(xhr.responseText);
                if (parsedResponseText && parsedResponseText.status) {
                    setLogin(parsedResponseText.name);
                }
            }
        });
        xhr.open('GET', 'https://europe-west1-makroskop-b14f3.cloudfunctions.net/ipBasedLogin', true);
        xhr.send();
    }, []);
    return /*#__PURE__*/ React.createElement(IPBasedLoginContext.Provider, {
        value: login
    }, children);
};
export default IPBasedLoginContext;
